import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { themeColorSet, ThemedText, ThemedView } from '@app/theme'
import Typography from '@sharedComponents/typography/Typography'
import BackButton from '@sharedComponents/BackButton/BackButton'
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema'
import useSingleRemoteConfig from '@app/hooks/useSingleRemoteConfig'
import ScreenWrapper from '@app/hoc/ScreenWrapper'
import Loading from '@app/sharedComponents/Loading/Loading'


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'PRODUCT_DETAILS'>

type ProductDetailsData = {
    label : string,
    value : string
}[]

const ProductDetails = ({ navigation , route }: ScreenProps) => {

    const { configValue, loading } = useSingleRemoteConfig('product_details')

    const productDetails : ProductDetailsData = configValue ? JSON.parse(configValue) : []


    if (loading) {
        return <Loading/>
    }
    return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true }}>
        <ThemedView bg='bg-surface-primary' flex={1}>
            <ThemedView borderBottomWidth={1} borderBottomColor='border-secondary' p='lg' flexDirection='row' alignItems='center'>
                <ThemedView mr='md'>
                    <BackButton navigation={navigation} />
                </ThemedView>
                <ThemedText variant='b3s' color='text-primary'>Product details</ThemedText>
            </ThemedView>
            <ThemedView padding='lg' pt='2xl'>
                <ThemedText variant='b3r' color='text-primary'>Loan against securities</ThemedText>
                <ThemedView borderColor='border-primary' backgroundColor={'bg-surface-primary'} style={{ marginTop: 16, borderWidth: 1,  borderRadius: 6, paddingHorizontal: 12, paddingVertical: 16 }}>
                    {productDetails.map((item, i) => {
                        return (
                            <>
                                <ThemedView flexDirection='row' justifyContent={'space-between'}>
                                    <ThemedText variant='b3r' color='text-primary'>{item?.label}</ThemedText>
                                    <ThemedText variant='b3r' color='text-primary'>{item?.value}</ThemedText>
                                </ThemedView>
                                {i != productDetails.length - 1 ? (
                                    <ThemedView marginVertical='lg'>
                                        <ThemedView height={1} backgroundColor='border-secondary' />
                                    </ThemedView>
                                ) : null}
                            </>
                        )
                    })}
                </ThemedView>
            </ThemedView>
        </ThemedView>
        </ScreenWrapper>
    )
}

export default ProductDetails

const styles = StyleSheet.create({})